import "./target.css";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useFetchData } from "../../../hooks/useFetchData";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useEffect, useState } from "react";

function Target() {
  const { auth } = useAuthContext();
  const { data, loading, error } = useFetchData("mandoub/leveldata?id=" + auth.user?._id, [auth]);
  const { data: stats } = useFetchData("mandoub/honeyTransaction");
  const [targetsArray, setTargetsArray] = useState([])
  const [categorySalesArray, setCategorySalesArray] = useState([])
  useEffect(() => {
    if(data?.success && data?.level.targets) {
      setTargetsArray(data?.level.targets)
    }
    
  }, [data])
  useEffect(() => {
    if(stats?.success && stats?.data.totalSalesByCategoryForCurrentMonth) {
      setCategorySalesArray(stats?.data.totalSalesByCategoryForCurrentMonth)
    }
    
  }, [stats])
  
  

  const getDeliveredQuantity = (categoryId) => {
    const categoryStats = stats?.totalSalesByCategoryForCurrentMonth?.find(
      (item) => item.category._id === categoryId
    );
    return categoryStats ? categoryStats.totalQuantity : 0;  // Return 0 if no sales found for the category
  };

  return (
    <div className="targets section-card df-c">
      <div className="title">الأهداف الشهرية</div>

      <div className="df jc-sa wrap pr">
      
        {targetsArray && targetsArray.map((target, index) => {
          const matchingCategorySale = categorySalesArray.find(
            sale => sale.category._id === target.category._id
          );
          const totalQuantity = matchingCategorySale ? matchingCategorySale.totalQuantity : 0;
          const percentage = (totalQuantity / target.monthlyTarget) * 100;

          return (
            <>
            {/* <div key={index} className="CompactCard">
              <div className={`radialBar`}>
                <CircularProgressbar value={percentage} text={`${Math.round(percentage)}%`} />
                <span>{remaining> 0 ? remaining : 0} كغ متبقية</span>
              </div>
              <div className="detail">
                <div className="df">
                  <img src={target.category.icon[0].url} className="w-12 h-12 object-cover" alt="" />
                  {target.category.name}
                </div>
                <span>{target.monthlyTarget} كغ</span>
                <span>{totalQuantity}/{target.monthlyTarget} تم التوصيل</span>
              </div>
            </div> */}
            <div class="flex items-center gap-5 p-4 compact rounded">
            <div class="flex flex-shrink-0 items-center justify-center bg-green-300 h-16 w-16 rounded">
              <img src={target.category.icon[0].url} className="w-12 h-12 object-cover" alt="" />
            </div>
            <div class="flex-grow flex flex-col ml-4">
              <span class="text-xl font-bold">{target.monthlyTarget} كغ {target.category.name}</span>
              <div class="flex items-center justify-between">
                <span class="text-gray-500">{totalQuantity}/{target.monthlyTarget} تم التوصيل</span>
              </div>
            </div>
            <div className={`radialBar`}>
                <CircularProgressbar value={percentage} text={`${(Math.round(percentage)> 100? 100 : Math.round(percentage))}%`} />
            </div>
          </div>
            </>
          );
        })}
        {/* {stats && data && data.level.rewardTarget && (
  <div className="CompactCard cyan">
    <div className="radialBar">
      {(() => {
        const totalQuantity = categorySalesArray.reduce((acc, item) => acc + item.totalQuantity, 0);
        const rewardTarget = data.level.rewardTarget;
        const percentage = (totalQuantity / rewardTarget) * 100;
        const roundedPercentage = Math.round(percentage);

        return (
          <>
            <CircularProgressbar value={percentage} text={`${roundedPercentage}%`} />
            <span>{`${rewardTarget - totalQuantity} كغ متبقية`}</span>
          </>
        );
      })()}
    </div>
    <div className="detail">
      <div className="df">
        <img src="https://cdn-icons-png.flaticon.com/512/9908/9908288.png" className="w-12 h-12 object-cover" alt="Default" />
        bonus
      </div>
      <span>{`${data.level.rewardTarget} كغ`}</span>
      <span>
        {`${categorySalesArray.reduce((acc, item) => acc + item.totalQuantity, 0)}/${data.level.rewardTarget} تم التوصيل`}
      </span>
    </div>
  </div>
)} */}

{stats && data && data.level.rewardTarget && (
         
          <div class="flex items-center gap-5 p-4 rounded bg-teal-50" style={{background: "#dff0ff"}}>
            
            <div class="flex flex-shrink-0 items-center justify-center bg-blue-400 h-16 w-16 rounded">
              <img src="https://cdn-icons-png.flaticon.com/512/9908/9908288.png" className="w-12 h-12 object-cover" alt="" />
            </div>
            <div class="flex-grow flex flex-col ml-4">
              <span class="text-xl font-bold">{data.level.rewardTarget} كغ</span>
              <div class="flex items-center justify-between">
                <span class="text-gray-500">{`${categorySalesArray.reduce((acc, item) => acc + item.totalQuantity, 0)}/${data.level.rewardTarget} تم التوصيل`}</span>
              </div>
            </div>
            <div className={`radialBar bonus`}>
            {(() => {
            const totalQuantity = categorySalesArray.reduce((acc, item) => acc + item.totalQuantity, 0);
            const rewardTarget = data.level.rewardTarget;
            const percentage = (totalQuantity / rewardTarget) * 100;
            const roundedPercentage = Math.round(percentage);

            return (
              <>
                <CircularProgressbar value={percentage} text={`${roundedPercentage}%`} />
              </>
            );
          })()}
            </div>
          </div>)}


      </div>
    </div>
  );
}

export default Target;
